import { useEffect, useState, useSyncExternalStore } from 'react';
import { clearToast, currentToast, subscribe } from './toastStore';
import s from './ui.module.css';

export function Toaster() {
  const value = useSyncExternalStore(subscribe, currentToast);
  // Последнее уведомление остаётся на экране ещё на мгновение, чтобы плавно уйти вниз.
  const [shown, setShown] = useState(value);
  // Пока курсор на уведомлении, оно не пропадает; после ухода мыши остаётся ещё на пару секунд.
  const [hover, setHover] = useState<{ readonly id: number; readonly now: boolean } | null>(null);
  const hovered = hover !== null && hover.id === value?.id && hover.now;
  const wasHovered = hover !== null && hover.id === value?.id;
  if (value !== null && value !== shown) setShown(value);
  const leaving = value === null && shown !== null;
  useEffect(() => {
    if (!leaving) return;
    const timer = setTimeout(() => {
      setShown(null);
    }, 180);
    return () => {
      clearTimeout(timer);
    };
  }, [leaving]);
  useEffect(() => {
    if (value === null || hovered) return;
    // С кнопкой — дольше: человеку нужно успеть нажать.
    const timer = setTimeout(
      () => {
        clearToast(value.id);
      },
      wasHovered ? 2000 : (value.duration ?? (value.action === undefined ? 2600 : 8000)),
    );
    return () => {
      clearTimeout(timer);
    };
  }, [value, hovered, wasHovered]);
  if (shown === null) return null;
  return (
    <div className={leaving ? `${s.toast} ${s.toastLeaving}` : s.toast} role="status"
      onMouseEnter={() => {
        setHover({ id: shown.id, now: true });
      }}
      onMouseLeave={() => {
        setHover({ id: shown.id, now: false });
      }}
    >
      <span className={s.toastText}>{shown.text}</span>
      {shown.action !== undefined && (
        <button
          type="button"
          className={s.toastAction}
          onClick={() => {
            shown.action?.onClick();
            clearToast(shown.id);
          }}
        >
          {shown.action.label}
        </button>
      )}
      {shown.second !== undefined && (
        <button
          type="button"
          className={s.toastAction}
          onClick={() => {
            shown.second?.onClick();
            clearToast(shown.id);
          }}
        >
          {shown.second.label}
        </button>
      )}
    </div>
  );
}
